/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum MarkupV2OrderValue {
    Supplier = 'Supplier',
    Carrier = 'Carrier',
    BrandAndMarket = 'BrandAndMarket',
    Channel = 'Channel',
    FareType = 'FareType',
    Relevance = 'Relevance'
}

export function MarkupV2OrderValueFromJSON(json: any): MarkupV2OrderValue {
    return MarkupV2OrderValueFromJSONTyped(json, false);
}

export function MarkupV2OrderValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkupV2OrderValue {
    return json as MarkupV2OrderValue;
}

export function MarkupV2OrderValueToJSON(value?: MarkupV2OrderValue | null): any {
    return value as any;
}

